import { SendEventProps } from '../../interfaces/biEvents';

export const mpShowAllClicked = () =>
    ({
        eventName: 'Notable clients - show all clicked',
    } satisfies SendEventProps);
